import {CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {DataStorageHelper} from 'amc-common-components';

/**
 * 'CtsDistributionGuard' class definition.
 */
@Injectable()
export class CtsDistributionGuard implements CanActivate {
	/**
	 * Constructor for CtsDistributionGuard class.
	 * @constructor
	 * @param {Router} router router
	 */
	constructor(private router: Router) {}

	/**
	 * Can activate.
	 * @returns {boolean}
	 */
	canActivate(): boolean {
		if (!DataStorageHelper.isPortal()) {
			void this.router.navigate(['']);
			return false;
		}

		return true;
	}
}
